import StockForm from './StockForm'

export default StockForm
